import styled, { css } from 'styled-components';

import { IconRegularChevronRight, theme } from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';

export const PopupBoxWrapper = styled.div`
  padding: 0.75rem;
  margin-top: 0.5rem;
  background: ${theme.color.background.secondary};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};

  &:hover {
    background: ${theme.color.background.secondaryHover};
  }
`;

export const Chevron = styled(IconRegularChevronRight)`
  color: ${theme.color.icon.tertiary};
  height: 1.25rem;
  width: 1.25rem;
  margin-left: auto;
`;

const imageStyles = css`
  height: 3rem;
  width: 3rem;
  object-fit: contain;
  mix-blend-mode: multiply;
`;

export const StyledImage = styled.img`
  ${imageStyles}
`;

export const StyledCdnImage = styled(CdnImage)`
  ${imageStyles}
`;

export const ImagePlaceholder = styled.div`
  height: 3rem;
  width: 3rem;
`;
